/* eslint-disable @typescript-eslint/no-explicit-any */
import { globals } from "@/main";
import { regenerateTokenService } from "@/services/apis/auth.service";
import { listMediaService } from "@/services/apis/media.service";
import { queryParams } from "@/services/utils/helper.util";
import { accessToken } from "@/services/utils/helper.util";

import {
  defineComponent,
  ref,
  computed,
  PropType,
  onMounted,
  watch,
} from "vue";
import { AxiosResponse } from "axios";

import MediaFromComputer from "./components/from-computer/index.vue";
import { api } from "@/dto/api.endpoint.dto";

type Directory = {
  code: string;
  title: string;
};
const initialDirectoryValue: Directory = { code: "", title: "" };

type FormType = {
  code: string[]; // Define the type of 'code' array
};

type MetaValue = {
  offset?: number;
  limit?: number;
  total?: number;
  page?: number;
  totalPage?: number;
};

export default defineComponent({
  name: "c-media",

  props: {
    value: {
      type: [String, Number, Array] as PropType<
        string | number | (string | number)[]
      >,
      validator: () => true,
    },
    isToggle: { type: Boolean, default: false },
    thumb: { type: String, default: "" },
    loading: { type: Boolean, default: false },
    style: { type: String, default: "" },
    class: { type: String, default: "" },
    format: { type: String, default: "jpg, jpeg, png, gif, webp, svg" },
    icon: { type: String, default: "" },
    schema: { type: Function, default: () => ({}) },
    refIds: { type: String, default: "refcomponentUpload" },
    isDelete: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    isArray: { type: Boolean, default: false },
    code: { type: String, default: "key" },
    folderKey: { type: String, default: "other" },
    mediaType: { type: Number, default: 1 },
    label: { type: String, default: "componentMedia" },
    size: { type: String, default: "5MB" },
    width: { type: String, default: "800 x 800px" },
    sizeLabel: { type: String, default: "componentMaxSize" },
    widthLabel: { type: String, default: "componentOptimalDimension" },
    isThumbnail: { type: Boolean, default: false },
    imageOnly: { type: Boolean, default: false },
    onload: { type: Boolean, default: false },
    custom: { type: Boolean, default: false },
  },

  components: {
    MediaFromComputer,
  },

  emits: [
    "update:value",
    "enter",
    "update:thumbnail",
    "update:upload",
    "update:isToggle",
    "onSelect",
  ],

  setup(props, { emit }) {
    const className = ref(props.class);
    const styleName = ref(props.style);
    const uploadIcon = ref(
      props.icon || require("@/assets/icons/sidebars/add-image.svg")
    );

    const newValue = computed(() => props.value);
    const isModal = ref(false);
    const meta = ref<MetaValue>({
      offset: 0,
      limit: 50,
      total: 0,
      page: 1,
      totalPage: 1,
    });
    const thumbnail = ref<any>(props.thumb);

    const onUpdateValue = (): void => {
      if (!props.isArray) {
        emit("update:value", []);
      }

      const codeValues = Array.isArray(form.value.code)
        ? form.value.code
        : [form.value.code];

      const propValues = props.isArray
        ? Array.isArray(props.value)
          ? props.value
          : [props.value]
        : [props.value];

      const combinedValues = props.isArray
        ? Array.from(new Set([...propValues, ...codeValues]))
        : codeValues;

      const newCombinedValues = combinedValues.filter(
        (v) => v !== thumbnail.value
      );

      emit("update:value", newCombinedValues);
      emit("onSelect", newCombinedValues);

      isModal.value = false;
      resetFrom();
    };

    const onBrowseFile = (): any => {
      isModal.value = true;
    };

    const onCloseBrowseFile = (): any => {
      onClose();
    };

    const onClose = (): void => {
      isModal.value = false;
      emit("update:isToggle", false);
      resetFrom();
    };

    const isLoading = computed(() => {
      return props.loading;
    });

    // start check scroll class
    const hasScroll = ref(false);

    const checkScroll = () => {
      const imageThumbnail = document.querySelector(
        ".image-thumbnail-active"
      ) as HTMLElement;

      const valueLength = Array.isArray(newValue.value)
        ? newValue.value.length
        : 1;
      const imageWidth = 147 * valueLength;

      if (imageWidth > imageThumbnail.clientWidth) {
        hasScroll.value = true;
      } else {
        hasScroll.value = false;
      }
    };
    // end check scroll class

    const onConfirmDelete = (data: any): void => {
      uploadIndex.value = "";

      emit("update:value", data);

      // if (Array.isArray(props.value)) {
      //   thumbnail.value = props.value[0];
      // } else {
      //   thumbnail.value = props.value;
      // }
    };

    const folders = globals.$store?.state?.medias || [];

    const tabFolders = [
      {
        code: "S001",
        value: "componentFromServer",
        title: "componentFromServer",
      },
      {
        code: "C001",
        value: "componentFromComputer",
        title: "componentFromComputer",
      },
    ];

    const activeFolder = ref("S001");

    const onTabChange = (value: any): void => {
      activeFolder.value = value;
      isDirectory.value = {
        code: "",
        title: "",
      };
      form.value.code = [];
      meta.value = {
        offset: 0,
        limit: 50,
        total: 0,
        page: 1,
        totalPage: 1,
      };
    };

    const isDirectory = ref(initialDirectoryValue);
    const isDirectoryLoading = ref(true);
    const directoriesImage = ref([]);

    const getMedia = async (): Promise<void> => {
      const folder = isDirectory.value;

      const params = queryParams({
        folder: folder?.code,
        type: 1, // Enum(1:IMAGE, 2:VIDEO, 3:DOCUMENT)
        offset: meta.value?.offset,
        limit: meta.value?.limit,
      });

      await listMediaService(params).then(async (response) => {
        if (response?.expired) {
          const refresh = await regenerateTokenService();
          if (refresh) {
            return await getMedia();
          }
        }

        directoriesImage.value =
          (response?.data &&
            response?.data.length && [
              ...directoriesImage.value,
              ...response?.data,
            ]) ||
          [];
        meta.value = response?.meta;
        isDirectoryLoading.value = false;
      });
    };

    const goBackDirectory = (): void => {
      resetFrom();
    };

    const resetFrom = (): void => {
      isDirectoryLoading.value = false;
      isDirectory.value = {
        code: "",
        title: "",
      };
      directoriesImage.value = [];
      form.value.code = [];
      meta.value = {
        offset: 0,
        limit: 50,
        total: 0,
        page: 1,
        totalPage: 1,
      };
    };

    const goDirectory = (value: any): void => {
      isDirectory.value = value;
      isDirectoryLoading.value = true;

      if (isDirectory.value) {
        getMedia();
      }
    };

    const form = ref<FormType>({
      code: [],
    });

    const onChangeSelected = (): void => {
      // checkScroll();
    };

    const onSelectMediaOnly = (media: any): void => {
      form.value.code = media;
    };

    const listMediaBody = ref<HTMLElement | null>(null);

    const handleScroll = (event: Event): void => {
      const target = event.target as HTMLElement;

      if (target.scrollHeight - target.scrollTop === target.clientHeight) {
        if (
          meta.value?.page !== undefined &&
          meta.value?.totalPage !== undefined &&
          meta.value.page < meta.value.totalPage &&
          !isDirectoryLoading.value
        ) {
          getMedia();
        }
      }
    };

    const onOrderThumbnail = (value: any) => {
      if (isFile(thumbnail.value) || thumbnail.value.startsWith("blob")) {
        files.value = files.value.concat(thumbnailFile.value);
        thumbnailFile.value = null;
        thumbnail.value = "";
      }

      if (thumbnail.value) {
        const mockValue = Array.isArray(newValue.value)
          ? newValue.value
          : [newValue.value];
        let formattedMockValue = mockValue;

        formattedMockValue = [thumbnail.value, ...formattedMockValue];
        thumbnail.value = value;
        formattedMockValue = formattedMockValue.filter(
          (v) => v?.toString() !== thumbnail.value
        );

        emit("update:thumbnail", thumbnail.value);
        emit("update:value", formattedMockValue);
      } else {
        thumbnail.value = value;
        const mockValue = Array.isArray(newValue.value)
          ? newValue.value
          : [newValue.value];
        let formattedMockValue = mockValue;

        formattedMockValue = [thumbnail.value, ...formattedMockValue];
        formattedMockValue = formattedMockValue.filter(
          (v) => v?.toString() !== thumbnail.value
        );

        emit("update:thumbnail", thumbnail.value);
        emit("update:value", formattedMockValue);
      }
    };

    const fileToPath = (file: File) => {
      return window.URL.createObjectURL(file);
    };

    const resetBody = () => {
      uploadPercentage.value = 0;
      files.value = [];
      if (fileInput.value !== null) {
        fileInput.value.value = "";
      }
    };

    const removeDraftFile = (arr: File[]) => {
      files.value = arr;
      uploadIndex.value = "";

      if (fileInput.value) {
        const dataTransfer = new DataTransfer();
        arr.forEach((file) => dataTransfer.items.add(file));
        fileInput.value.files = dataTransfer.files;
      }
    };

    const supportedTypes = ["Files"];
    let dragCounter = 0;

    const handleDragEnter = (e: DragEvent) => {
      e.preventDefault();

      if (props.readonly) return;

      dragCounter++;

      if (dragCounter === 1) {
        activeDrag.value = true;
      }
    };

    const handleDragOver = (e: DragEvent) => {
      e.preventDefault();

      if (props.readonly) return;

      if (e.dataTransfer && supportedTypes.includes(e.dataTransfer.types[0])) {
        e.dataTransfer.dropEffect = "copy";
      }
    };

    const handleDragLeave = () => {
      if (props.readonly) return;

      dragCounter--;

      if (dragCounter === 0) {
        activeDrag.value = false;
      }
    };

    const handleDrop = (e: DragEvent) => {
      e.preventDefault();

      if (props.readonly) return;

      activeDrag.value = false;
      dragCounter = 0; // Reset drag counter on drop

      if (!props.isArray) {
        emit("update:value", "");
      }

      const validExtensions = ["jpg", "jpeg", "png"];

      if (e.dataTransfer && e.dataTransfer.files.length > 0) {
        const droppedFilesWithIndex = Array.from(e.dataTransfer.files).map(
          (file, index) => ({ file, index })
        );
        const sortedFilesWithIndex = droppedFilesWithIndex.sort(
          (a, b) => a.index - b.index
        );
        const sortedFiles = sortedFilesWithIndex.map((item) => item.file);

        if (fileInput.value) {
          fileInput.value.value = "";

          const dataTransfer = new DataTransfer();
          const existingFileNames = new Set(
            files.value.map((file) => file.name)
          );

          invalidFiles.value = [];

          const maxSize =
            parseInt(props.size.replace("MB", "").trim()) * 1024 * 1024; // Convert MB to bytes

          for (const file of sortedFiles) {
            const fileExtension = file.name.split(".").pop()?.toLowerCase();

            // Check if the file size is valid
            if (file.size > maxSize) {
              invalidFiles.value.push({
                label: "componentFileTooLarge",
                value: `<span>${
                  file.name
                }</span><span style="color: var(--danger);margin-left: 5px;">(Error: Max size: 5 MB, Got ${(
                  file.size /
                  (1024 * 1024)
                ).toFixed(2)} MB)</span>`,
                message: "Max size is 5 MB",
              });
              continue; // Skip further checks for this file
            }

            // Check if the file extension is valid
            if (fileExtension && validExtensions.includes(fileExtension)) {
              if (!existingFileNames.has(file.name)) {
                dataTransfer.items.add(file);
                existingFileNames.add(file.name);
              }
            } else {
              invalidFiles.value.push({
                label: "componentInvalidFileType",
                value: `<span>${file.name}</span><span style="color: var(--danger);margin-left: 5px;">(Error: Invalid file type - Extension: .${fileExtension}) </span>`,
                message: "Invalid file type",
              });
            }
          }

          fileInput.value.files = dataTransfer.files;
          onChange();
        }
      }
    };

    const onChange = () => {
      const input = fileInput.value;

      if (input && input.files) {
        const newFiles = Array.from(input.files);

        if (props.isArray) {
          files.value = files.value.filter(
            (existingFile) =>
              !newFiles.some((newFile) => existingFile.name === newFile.name)
          );

          for (const newFile of newFiles) {
            const isDuplicate = files.value.some(
              (existingFile) => existingFile.name === newFile.name
            );

            if (!isDuplicate) {
              files.value.push(newFile);
            }
          }

          files.value.sort((a, b) => {
            const indexA = newFiles.findIndex((file) => file.name === a.name);
            const indexB = newFiles.findIndex((file) => file.name === b.name);
            return indexA - indexB;
          });
        } else {
          if (newFiles.length > 0) {
            files.value = [newFiles[0]];
          }
        }

        if (newFiles.length === 1) {
          beforeUploadIndex.value = 0;
        }
      }

      activeDrag.value = false;
    };

    const onOrderThumbnailFile = (value: File, thumbnailValue: string) => {
      if (!thumbnailValue.startsWith("blob") && isFile(value)) {
        const mockValue = Array.isArray(newValue.value)
          ? newValue.value
          : [newValue.value];
        let formattedMockValue = mockValue;

        formattedMockValue = [thumbnailValue, ...formattedMockValue];
        emit("update:value", formattedMockValue);
      }

      if (isFile(value)) {
        if (isValidImageFile(value)) {
          thumbnail.value = fileToPath(value);
        }
      } else {
        thumbnail.value = value;
      }

      const findingFile = files.value.filter((file) => file === value);

      if (
        fileInput.value &&
        fileInput.value.files &&
        !thumbnailFile.value &&
        findingFile
      ) {
        files.value = files.value.filter((file) => file !== value);
        const dataTransfer = new DataTransfer();

        Array.from(fileInput.value.files).forEach((file) => {
          if (file !== thumbnailFile.value) {
            dataTransfer.items.add(file);
          }
        });

        fileInput.value.files = dataTransfer.files;
      } else if (
        fileInput.value &&
        fileInput.value.files &&
        thumbnailFile.value &&
        thumbnailFile.value !== value
      ) {
        files.value = files.value.concat(thumbnailFile.value);
        files.value = files.value.filter((file) => file !== value);
        const updatedDataTransfer = new DataTransfer();

        Array.from(fileInput.value.files).forEach((file) => {
          if (file !== thumbnailFile.value) {
            updatedDataTransfer.items.add(file);
          }
        });

        fileInput.value.files = updatedDataTransfer.files;
      }

      thumbnailFile.value = value;
    };

    const isValidImageFile = (file: File): boolean => {
      const validImageTypes = ["image/jpg", "image/jpeg", "image/png"];
      const validExtensions = ["jpg", "jpeg", "png"];

      // Check MIME type
      const isValidMimeType = validImageTypes.includes(file.type);

      // Check file extension
      const fileExtension = file.name.split(".").pop()?.toLowerCase();
      const isValidExtension = fileExtension
        ? validExtensions.includes(fileExtension)
        : false;

      return isValidMimeType || isValidExtension;
    };

    const isFile = (value: any): value is File => {
      return value instanceof File;
    };

    const mockNewValues = ref();
    const thumbnailFile = ref();
    const files = ref<File[]>([]);
    const fileInput = ref<HTMLInputElement | null>(null);
    const beforeUploadIndex = ref(-1);
    const isUploading = ref(false);
    const errorMessage = ref("");
    const uploadPercentage = ref<number>(0);
    const fileUploaded = ref<File[]>([]);
    const selectedIndex = ref(-1);
    const uploadIndexIndex = ref(-1);
    const responseBody = ref("");
    const activeDrag = ref(false);
    const invalidFiles = ref<any[]>([]);

    // service upload
    const beforeUpload = async () => {
      if (!thumbnailFile.value && files.value && !files.value.length) {
        emit("update:upload", false, true);
        return;
      }

      if (thumbnailFile.value) {
        isUploading.value = true;
        uploadIndexIndex.value = 0;

        const response: any = await onUpload(thumbnailFile.value);

        if (error.value) {
          isUploading.value = false;
          uploadPercentage.value = 0;
          uploadIndexIndex.value = -1;
          emit("update:upload", false, false);
          invalidFiles.value.push({
            label: "componentInvalidFileType",
            value: `<span style="color: var(--danger);">Error: ${response?.response?.data?.message}</span>`,
            message: "Invalid File Upload",
          });
          error.value = false;
          return;
        }

        handleUploadResponse(response, true);

        if (typeof response === "string" || response?.status !== 201) {
          uploadPercentage.value = 0;
          isUploading.value = false;
          uploadIndexIndex.value = -1;
          return;
        }

        thumbnailFile.value = "";
        thumbnail.value = response?.data?.data?.key;
        emit("update:thumbnail", thumbnail.value);

        isUploading.value = false;
        uploadIndexIndex.value = -1;

        if (files.value && files.value.length) {
          updateUploaderFiles();
        } else {
          emit("update:upload", false, true);
        }
      } else {
        updateUploaderFiles();
      }
    };

    const handleUploadResponse = (
      response: AxiosResponse<any> | string,
      isThumbnail = false
    ) => {
      if (typeof response === "string") {
        uploadPercentage.value = 0;
        errorMessage.value = response;
      } else {
        if (response?.status === 201) {
          if (isThumbnail) {
            // Additional thumbnail-specific processing can be done here
          }
        } else {
          uploadPercentage.value = 0;
          errorMessage.value = response?.data?.message || "Upload failed.";
        }
      }
    };

    const updateFileInputFiles = () => {
      if (fileInput.value) {
        const dataTransfer = new DataTransfer();

        for (const file of files.value) {
          dataTransfer.items.add(file);
        }

        fileInput.value.files = dataTransfer.files;
      }
    };

    const updateUploaderFiles = async () => {
      try {
        if (files.value.length > 0) {
          isUploading.value = true;

          for (let i = 0; i < files.value.length; i++) {
            uploadIndexIndex.value = i;
            const response: any = await onUpload(files.value[i]);

            if (error.value) {
              isUploading.value = false;
              uploadPercentage.value = 0;
              uploadIndexIndex.value = -1;
              emit("update:upload", false, false);
              invalidFiles.value.push({
                label: "componentInvalidFileType",
                value: `<span style="color: var(--danger);">Error: ${response?.response?.data?.message}</span>`,
                message: "Invalid File Upload",
              });
              error.value = false;
              return;
            }

            if (typeof response === "string") {
              handleUploadResponse(response);
              break;
            } else {
              handleUploadResponse(response);
              if (response?.status === 201) {
                files.value.splice(i, 1);
                updateFileInputFiles();

                const mockValue = Array.isArray(newValue.value)
                  ? newValue.value.filter(Boolean)
                  : [newValue.value].filter(Boolean);

                const uniqueValues = new Set(mockValue);
                uniqueValues.add(response?.data?.data?.key);
                const formattedMockValue = Array.from(uniqueValues);

                emit("update:value", formattedMockValue);
                i--;
              } else {
                break;
              }
            }
          }

          isUploading.value = false;
          uploadIndexIndex.value = -1;
          emit("update:upload", false, true);
        }
      } catch (error: any) {
        globals.$toast(`Error resolving issues: ${error?.message}`, "danger");
      }
    };

    const onUpload = async (
      file: File
    ): Promise<AxiosResponse<any> | string> => {
      const formData = new FormData();
      formData.append("file", file);
      uploadIndex.value = "";

      const token = await accessToken;
      const params =
        "?folder=" +
        props.folderKey +
        "&type=" +
        props.mediaType +
        "&accept-language=en:en";

      const header = {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + token.value,
        },
        onUploadProgress: function (progressEvent: ProgressEvent) {
          const percentage = Math.round(
            (progressEvent.loaded / progressEvent.total) * 100
          );
          uploadPercentage.value = percentage;
        },
      };

      try {
        const response: any = await globals.$axios.post(
          api.uploadMedia + params,
          formData,
          header
        );

        return response;
      } catch (errors: any) {
        emit("update:upload", true, false);
        error.value = true;
        invalidFiles.value = [];
        uploadError.value = true;
        uploadIndex.value = file.name;

        return { ...errors, customError: true };
      }
    };

    const error = ref(false);
    const uploadError = ref();
    const uploadIndex = ref();

    onMounted(() => {
      // checkScroll();
    });

    watch(
      [() => props.thumb, () => props.onload],
      ([newThumb, newOnload]) => {
        if (newThumb) {
          thumbnail.value = newThumb;
        }

        if (newOnload) {
          emit("update:upload", true, true);
          beforeUpload();
        }
      },
      { immediate: true }
    );

    watch(
      () => props.isToggle,
      (value) => {
        if (value) isModal.value = true;
      }
    );

    return {
      className,
      styleName,
      isLoading,
      uploadIcon,
      onUpdateValue,
      newValue,
      onBrowseFile,
      hasScroll,
      isModal,
      onCloseBrowseFile,
      onConfirmDelete,
      folders,
      tabFolders,
      activeFolder,
      onTabChange,
      isDirectory,
      goDirectory,
      isDirectoryLoading,
      directoriesImage,
      goBackDirectory,
      isArr: props.isArray,
      onChangeSelected,
      form,
      onSelectMediaOnly,
      handleScroll,
      listMediaBody,

      thumbnail,
      onOrderThumbnail,
      checkScroll,

      // upload
      handleDrop,
      handleDragOver,
      handleDragEnter,
      fileInput,
      onChange,

      removeDraftFile,
      fileToPath,
      isUploading,
      errorMessage,
      fileUploaded,
      resetBody,
      responseBody,
      uploadIndexIndex,
      selectedIndex,
      mockNewValues,
      onOrderThumbnailFile,
      files,
      activeDrag,
      handleDragLeave,
      invalidFiles,
      supportedTypes,
      uploadPercentage,
      uploadError,
      uploadIndex,
    };
  },
});
